var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},[_c('div',{staticClass:"grid__col-12"},[_c('data-use-terms',{attrs:{"handle-submit":_vm.handleSubmit,"submit-button-text":"Submit"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }